import React from 'react';

import Date from '../../../common/date';
import { formatAmount } from '../../../common/money';

export default [
  {
    Header: 'Date',
    accessor: 'date',
    className: 'u-text-left',
    Cell: ({ value }) => <Date>{value}</Date>,
  },
  {
    Header: 'Retail Value',
    accessor: 'retailValuation',
    Cell: ({ value }) => value === null ? 'N/A' : formatAmount(value),
  },
  {
    Header: 'Wholesale (Supply) Value',
    accessor: 'supplyValuation',
    Cell: ({ value }) => value === null ? 'N/A' : formatAmount(value),
  },
];
